import { ExtensionType, utils, settings, extensions } from '@pixi/core';
import { AnimatedGIF } from './AnimatedGIF.mjs';
const AnimatedGIFAsset = {
  extension: ExtensionType.Asset,
  detection: {
    test: async () => true,
    add: async formats => [...formats, "gif"],
    remove: async formats => formats.filter(format => format !== "gif")
  },
  loader: {
    test: url => utils.path.extname(url) === ".gif",
    load: async (url, asset) => {
      const response = await settings.ADAPTER.fetch(url);
      const buffer = await response.arrayBuffer();
      return AnimatedGIF.fromBuffer(buffer, asset?.data);
    },
    unload: async asset => {
      asset.destroy();
    }
  }
};
extensions.add(AnimatedGIFAsset);
export { AnimatedGIFAsset };
